    import React, { useState, useEffect } from "react";
    import { useNavigate } from "react-router-dom";
    import { auth } from "./firebase";
    import axios from "axios";
    import Navbar from "./Navbar";
    import "./Planes.css"; // Hoja de estilos personalizada
    import { collection, getDocs } from "firebase/firestore";
    import { db } from "./firebase";

    const featureTitles = [
      "Alertas por email cuando baje el precio",
      "Máximo de URLs",
      "Activar / desactivar alertas",
      
    ];

    function Planes() {
      const [plans, setPlans] = useState([]);
      const navigate = useNavigate();
      const user = auth.currentUser;

      useEffect(() => {
        async function fetchPlans() {
          try {
            const querySnapshot = await getDocs(collection(db, "plans"));
            const loadedPlans = [];
            querySnapshot.forEach((doc) => {
              loadedPlans.push({ id: doc.id, ...doc.data() });
            });
            setPlans(loadedPlans);
          } catch (error) {
            console.error("Error al cargar los planes:", error);
          }
        }
        fetchPlans();
      }, []);



      const handleSubscribe = async (planId) => {
        
        try {

          const idToken = await auth.currentUser.getIdToken()

          const response = await fetch(
            "https://europe-west1-avisamesibaja-be02c.cloudfunctions.net/createCheckoutSession",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${idToken}`,
              },
              body: JSON.stringify({
                planId,
              }),
            }
          );

          if (!response.ok) throw new Error(await res.text());

          const result = await response.json();
          console.log("Respuesta" + result);

          window.location.href = result.url; // ✅ Esto es lo correcto

        } catch (error) {
          console.error("Error al redirigir a Stripe:", error);
          alert("Error al procesar el pago. Intenta de nuevo.");
        }
      };

      return (
        <div className="planes-container">
          <Navbar user={user} />
          <h1 className="planes-title">Nuestros Planes</h1>
          <div className="table-wrapper">
            <table className="plans-table">
              <thead>
                <tr>
                  <th>Características</th>
                  {plans.map((plan) => (
                    <th key={plan.id} style={{ color: plan.color }}>
                      {plan.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {featureTitles.map((feature, i) => (
                  <tr key={feature}>
                    <td>{feature}</td>
                    {plans.map((plan) => (
                      <td key={plan.id + i}>
                        {typeof plan.features[i] === "string"
                          ? plan.features[i]
                          : plan.features[i]
                          ? "✅"
                          : "❌"}
                      </td>
                    ))}
                  </tr>
                ))}
                <tr>
                  <td></td>
                  {plans.map((plan) => (
                    <td key={plan.id}>
                      <h3>${plan.price}</h3>
                      <button
                        style={{ backgroundColor: plan.color }}
                        onClick={() => handleSubscribe(plan.id)}
                      >
                        COMPRAR
                      </button>
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      );
    }

    export default Planes;
